import React from 'react';
import { motion } from 'framer-motion';
import { ChefHat, Sparkles, Calendar } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 bg-forest text-warm-white overflow-hidden" data-id="element-70">
      <div className="container mx-auto px-4" data-id="element-71">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-72">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} data-id="element-73">
            <span className="text-golden font-medium tracking-widest uppercase text-sm mb-2 block" data-id="element-74">
              El Secreto
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-6 font-serif" data-id="element-75">
              El Sistema "3 Bases, 15 Platos"
            </h2>
            <p className="text-xl text-warm-white/90 leading-relaxed" data-id="element-76">
              He diseñado un sistema específicamente para la mujer latina que
              vive el ritmo acelerado de USA. No vas a cocinar "recetas"
              sueltas. Vas a preparar{' '}
              <span className="text-golden font-bold" data-id="element-77">3 BASES MAESTRAS</span> el
              domingo.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-78">
          {/* Step 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20" data-id="element-79">
            <div className="bg-golden text-forest w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl mb-6" data-id="element-80">
              1
            </div>
            <h3 className="text-2xl font-bold mb-4 font-serif text-golden" data-id="element-81">
              Domingo: 90 Minutos
            </h3>
            <p className="text-warm-white/80" data-id="element-82">
              Dedicas solo una hora y media el domingo para preparar tus 3 bases
              maestras. Sin estrés, con tu música favorita.
            </p>
          </motion.div>

          {/* Step 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 relative" data-id="element-83">
            <div className="absolute top-0 right-0 p-4 opacity-20" data-id="element-84">
              <Sparkles className="w-16 h-16 text-golden" data-id="element-85" />
            </div>
            <div className="bg-golden text-forest w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl mb-6" data-id="element-86">
              2
            </div>
            <h3 className="text-2xl font-bold mb-4 font-serif text-golden" data-id="element-87">
              La Magia de la Base
            </h3>
            <p className="text-warm-white/80" data-id="element-88">
              Ese pollo base no es solo pollo. El lunes se convierte en{' '}
              <span className="text-white font-semibold" data-id="element-89">Tacos Dorados</span>.
              El martes en un{' '}
              <span className="text-white font-semibold" data-id="element-90">Bowl Tropical</span>.
            </p>
          </motion.div>

          {/* Step 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20" data-id="element-91">
            <div className="bg-golden text-forest w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl mb-6" data-id="element-92">
              3
            </div>
            <h3 className="text-2xl font-bold mb-4 font-serif text-golden" data-id="element-93">
              Semana: 10 Minutos
            </h3>
            <p className="text-warm-white/80" data-id="element-94">
              Llegas de trabajar y solo ensamblas. El miércoles disfrutas{' '}
              <span className="text-white font-semibold" data-id="element-95">Arepas rellenas</span>{' '}
              en menos tiempo del que toma hervir agua.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}